import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import API from './utils/api';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import AmbientBackground from './components/AmbientBackground';
import Footer from './components/Footer';
import CartSidebar from './components/CartSidebar';
import ProtectedRoute from './components/ProtectedRoute';

import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import Login from './pages/Login';
import Register from './pages/Register';
import TrackOrder from './pages/TrackOrder';
import MyOrders from './pages/MyOrders';

import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import AdminOrders from './pages/admin/AdminOrders';
import AdminCoupons from './pages/admin/AdminCoupons';
import AdminSettings from './pages/admin/AdminSettings';
import AdminLanding from './pages/admin/AdminLanding';
import AdminBranches from './pages/admin/AdminBranches';

import PrivacyPolicy from './pages/policies/PrivacyPolicy';
import ShippingDelivery from './pages/policies/ShippingDelivery';
import RefundCancellation from './pages/policies/RefundCancellation';
import TermsConditions from './pages/policies/TermsConditions';
import ContactUs from './pages/policies/ContactUs';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    API.get('/api/settings').then(({ data }) => {
      if (window.location.pathname.startsWith('/admin')) return;
      const theme = data.theme || 'midnight-gold';
      document.documentElement.setAttribute('data-theme', theme);
    }).catch(() => {});
  }, []);

  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="coupons" element={<AdminCoupons />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="landing" element={<AdminLanding />} />
              <Route path="branches" element={<AdminBranches />} />
            </Route>
            <Route path="*" element={<MainLayout />} />
          </Routes>
          <ToastContainer position="top-right" autoClose={3000} theme="dark" toastStyle={{ background: '#1a1a1a', color: '#f0e6c8', border: '1px solid #c9a84c' }} />
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

function MainLayout() {
  useEffect(() => {
    API.get('/api/settings').then(({ data }) => {
      const theme = data.theme || 'midnight-gold';
      document.documentElement.setAttribute('data-theme', theme);
    }).catch(() => {});
  }, []);

  return (
    <>
      <AmbientBackground />
      <Navbar />
      <CartSidebar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/track-order" element={<TrackOrder />} />
        <Route path="/my-orders" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/shipping-delivery" element={<ShippingDelivery />} />
        <Route path="/refund-cancellation" element={<RefundCancellation />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/contactus" element={<ContactUs />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
